module.exports = __webpack_public_path__ + "media/images/story/illust/thanks-bird-592f79023ed06efeb1ebc1164ab10359.png";